module.exports = __webpack_public_path__ + "img/topicMedicalServices.3bbecea7.png";